import { Grid3x3, PhoneMissed } from 'lucide-react';
import type { MissedCall } from '../../hooks/useMissedCalls';
import { MissedCallRow } from './MissedCallRow';

interface MissedCallsListProps {
  calls: MissedCall[];
  loading: boolean;
  error: string | null;
  onHandled: (callerE164: string) => void;
  onOpenPad: () => void;
}

/** Callers of the last 14 days still to call back (one row per number). */
export function MissedCallsList({ calls, loading, error, onHandled, onOpenPad }: MissedCallsListProps) {
  if (loading) {
    return (
      <div className="space-y-3 p-3" aria-busy="true">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex gap-2.5">
            <div className="h-4 w-4 rounded bg-desk-subtle" />
            <div className="flex-1 space-y-1.5">
              <div className="h-3 w-2/3 rounded bg-desk-subtle" />
              <div className="h-2.5 w-1/3 rounded bg-desk-subtle" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div>
      {error && <p className="border-b border-red-100 bg-red-50 px-3 py-2 text-xs text-red-600 dark:border-red-900 dark:bg-red-950 dark:text-red-400">{error}</p>}
      {calls.length === 0 ? (
        <div className="flex flex-col items-center px-4 py-8 text-center">
          <PhoneMissed className="h-6 w-6 text-desk-faint" />
          <p className="mt-2 text-sm font-medium text-desk-soft">Personne à rappeler</p>
          <p className="mt-0.5 text-xs text-desk-muted">Les appels manqués des 14 derniers jours s'affichent ici.</p>
          <button
            type="button"
            onClick={onOpenPad}
            className="mt-3 inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium text-desk-ink hover:bg-desk-hover"
          >
            <Grid3x3 className="h-3.5 w-3.5" />
            Composer un numéro
          </button>
        </div>
      ) : (
        <ul className="max-h-[70vh] divide-y divide-desk-line overflow-y-auto sm:max-h-[420px]">
          {calls.map((c) => (
            <MissedCallRow key={c.caller_e164} call={c} onHandled={onHandled} />
          ))}
        </ul>
      )}
    </div>
  );
}
